import { Code2, Brain, GraduationCap, Server, LineChart, ShieldCheck, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = [Code2, Brain, GraduationCap, Server, LineChart, ShieldCheck];

export default function Services() {
  return (
    <div className="pt-24 md:pt-32">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-16">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">
            <span className="inline-block w-6 h-px bg-neutral-400" />
            What We Do
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-5xl">
            End-to-end technology solutions for growth.
          </h1>
          <p className="mt-8 text-lg text-neutral-600 max-w-3xl leading-relaxed">
            We engineer bespoke digital solutions that drive enterprise automation, leverage cognitive
            intelligence, and accelerate career capability.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={s.title} delay={i * 60}>
                <div className="bg-white border border-neutral-200 rounded-2xl p-8 h-full group hover:border-neutral-900 transition-colors">
                  <div className="w-12 h-12 rounded-full border border-neutral-200 grid place-items-center mb-6 group-hover:bg-neutral-950 group-hover:text-white group-hover:border-neutral-950 transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif text-2xl tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{s.intro}</p>
                  <ul className="mt-6 space-y-2 text-sm text-neutral-700">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-start gap-2">
                        <span className="mt-1.5 inline-block w-1 h-1 rounded-full bg-neutral-950" />
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-neutral-950 text-white py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Let’s build something extraordinary together.
            </h2>
          </div>
          <div className="md:text-right">
            <Link to="/contact" className="btn-pill" style={{ background: "#fff", color: "#0a0a0a" }}>
              Talk to our team
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
